
const getCurrentYear = (): number => new Date().getFullYear();

export {
  getCurrentYear
};
